import initApp from "./packages/core.js";

// Bind the main app initialization function
export default initApp.bind(globalThis);
